import React from "react";
import SelectBox from "devextreme-react/select-box";
import TextBox from "devextreme-react/text-box";
import Button from "devextreme-react/button";

const operators = [
  { id: "equals", name: "Equals" },
  { id: "notequals", name: "Not Equals" },
  { id: "contains", name: "Contains" },
  { id: "greaterThan", name: "Greater Than" },
  { id: "lessThan", name: "Less Than" },
  { id: "startswith", name: "Starts With" },
  { id: "endswith", name: "Ends With" },
  { id: "between", name: "Between" },
  { id: "isblank", name: "Is Blank" },
  { id: "isnotblank", name: "Is Not Blank" },
  { id: "inlist", name: "In List" },
  { id: "not in list", name: "Not In List" },
];

export default function FilterBuilder({ filters, setFilters, fields }) {

  const addFilter = () => {
    setFilters([
      ...filters,
      {
        id: crypto.randomUUID(),
        logic: "AND",
        field: "",
        operator: "equals",
        value: ""
      }
    ]);
  };

  const updateFilter = (id, key, value) => {
    setFilters(filters.map(f => f.id === id ? { ...f, [key]: value } : f));
  };

  const removeFilter = (id) => {
    setFilters(filters.filter(f => f.id !== id));
  };

  return (
    <div className="card">

      {/* HEADER */}
      <div className="section-header">
        <h3>Filters</h3>
        <Button
          text="Add Filter"
          icon="plus"
          type="default"
          onClick={addFilter}
          elementAttr={{ class: "btn-addFilter" }}
        />
      </div>

      {/* HINT TEXT */}
      <div className="filter-hint">
        The first row starts the filter. Additional rows use AND / OR.
      </div>

      {/* HEADER ROW */}
      <div className="filter-header">
        <div>Logic</div>
        <div>Field</div>
        <div>Operator</div>
        <div>Value</div>
        <div></div>
      </div>

      {/* FILTER ROWS */}
      {filters.map((f, index) => (
        <div className="filter-row" key={f.id}>

          <SelectBox
            items={["AND", "OR"]}
            value={index === 0 ? "AND" : f.logic}
            disabled={index === 0}
            onValueChanged={(e) => updateFilter(f.id, "logic", e.value)}
          />

          <SelectBox
            items={fields}
            valueExpr="fieldName"
            displayExpr="friendlyLabel"
            value={f.field}
            searchEnabled
            onValueChanged={(e) => updateFilter(f.id, "field", e.value)}
          />

          <SelectBox
            items={operators}
            valueExpr="id"
            displayExpr="name"
            value={f.operator}
            onValueChanged={(e) => updateFilter(f.id, "operator", e.value)}
          />

          <TextBox
            value={f.value}
            placeholder="Value"
            onValueChanged={(e) => updateFilter(f.id, "value", e.value)}
          />

          <div className="button-cell">
            <Button
              text="Remove"
              stylingMode="outlined"
              onClick={() => removeFilter(f.id)}
            />
          </div>

        </div>
      ))}

    </div>
  );
}